import React from 'react'
import './style.scss'
import Spinner from 'react-bootstrap/Spinner';

const LoginBtn = ({ text, onClick, disabled, loading, whiteBtn }) => {
    return (
        <button className={`${whiteBtn ? "white__btn" : ""} login__btn__main`} onClick={onClick} disabled={disabled}>
            {loading ? <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner> : text}
        </button>
    )
}

export default LoginBtn